import { apiClient } from '@/services/api';

export interface GradeBand {
  min: number;
  color: string;
  label: string;
}

export interface ScoringContentResponse {
  content: {
    gradeInterpretations?: {
      conditionScore?: Record<string, string>;
      contextScore?: Record<string, string>;
    };
    assessmentSummary?: { conditionScore?: string; contextScore?: string };
    conditionScoreInsights?: string;
    contextScoreInsights?: string;
  } | null;
  gradeBands: Record<string, GradeBand> | null;
}

export const getScoringContent = async (): Promise<ScoringContentResponse> => {
  const response = await apiClient.get<ScoringContentResponse>('/scoring-content');
  return response.data;
};
